// extracted by mini-css-extract-plugin
export default {"root":"Layout_root__L-xad","layout":"Layout_layout__8cGUY","layout__content":"Layout_layout__content__xlABf"};